import { render } from "./RecipeModal.vue?vue&type=template&id=7b8ce3c0"
import script from "./RecipeModal.vue?vue&type=script&lang=js"
export * from "./RecipeModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__